import React from 'react';
// @ts-ignore
import Parcel from 'single-spa-react/lib/esm/parcel';
import { mountRootParcel } from 'single-spa';
import { compose } from 'recompose';
import { parse } from 'url';
import { passApplication } from '@unitedtraders/application-bootstrapper';
import { translate } from '../utils/translateUtils';
import { getUtClientId } from '../utils/utClientId';
import { getGaClientId } from '../utils/gaClientId';

const enhance = compose(translate, passApplication);

const AuthModalView = ({
  baseUrl,
  onClose,
  application: { authorization, settings },
  application,
  lng
}) => {
  const config = {
    keycloak: settings.get('keycloak'),
    sessionService: settings.get('sessionService'),
    utcomGateway: {
      rest: {
        url: parse(settings.get('grpcGateway').url)
      }
    }
  };
  return (
    <Parcel
      config={() => import('@unitedtraders/auth-microfrontend')}
      mountParcel={mountRootParcel}
      locale={lng}
      setTokens={tokens => authorization.setTokens(tokens)}
      baseUrl={baseUrl}
      product="UTCOM"
      getTokens={() => authorization.getTokens()}
      configs={config}
      featureFlags={{ registerWithEmail: settings.get('registerWithEmail', true) }}
      isUserAuthenticated={authorization.isAuthenticated()}
      closeModal={() => (application.onAuthClose ? application.onAuthClose() : onClose())}
      landing={window.location.href}
      getGaId={getGaClientId}
      getClientId={getUtClientId}
    />
  );
};

export const AuthModal = enhance(AuthModalView);



// WEBPACK FOOTER //
// ./src/components/AuthModal.jsx